export enum MessagesQueueType {
  SYSTEM_QUEUE = 'SYSTEM_QUEUE',
  CUSTOM_QUEUE = 'CUSTOM_QUEUE',
  FAVORITE = 'FAVORITE',
  RECENT_SEARCH = 'RECENT_SEARCH',
  TEMPLATES = 'TEMPLATES',
  CALLBACK = 'CALLBACK',
}
